import { render } from "./GalleryFramePreviewComponent.vue?vue&type=template&id=3ecbe58f&scoped=true&ts=true"
import script from "./GalleryFramePreviewComponent.vue?vue&type=script&lang=ts"
export * from "./GalleryFramePreviewComponent.vue?vue&type=script&lang=ts"

import "./GalleryFramePreviewComponent.vue?vue&type=style&index=0&id=3ecbe58f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ecbe58f"]])

export default __exports__